export default __webpack_public_path__ + "static/media/view.b264b62d.png";